import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';
import { filledBlocks } from '../../utils/nearby';

const MAX_BLOCKS = 24;

/**
 * Site headline: big "3 of 20 free right now" with one block per charger
 * (scaled down proportionally for very large sites).
 */
export function AvailabilityHero({
  available,
  total,
}: {
  available: number;
  total: number;
}) {
  const { t } = useTranslation();
  const blocks = Math.min(total, MAX_BLOCKS);
  const filled = filledBlocks(available, total, MAX_BLOCKS);

  return (
    <div>
      <div className="flex items-baseline gap-2">
        <span
          className={cn(
            'text-[56px] font-semibold leading-[0.9] tracking-[-0.05em] tabular-nums',
            available > 0
              ? 'text-ok dark:[text-shadow:0_0_30px_rgb(var(--c-ok)/0.45)]'
              : 'text-muted'
          )}
        >
          {available}
        </span>
        <span className="text-lg text-muted">
          {t('chargePoint.freeNow', { total })}
        </span>
      </div>
      <div className="mt-3 flex gap-[3px]" aria-hidden>
        {Array.from({ length: blocks }, (_, i) => (
          <span
            key={i}
            className={cn(
              'h-1.5 flex-1 rounded-full',
              i < filled
                ? 'bg-ok dark:shadow-[0_0_10px_rgb(var(--c-ok)/0.6)]'
                : 'bg-ink/10'
            )}
          />
        ))}
      </div>
    </div>
  );
}
